(() => {
  let o = (t) => {
      if (t) {
        var s = t.parentNode.parentNode.querySelector(
            ".products-with-tabs__navigation",
          ),
          r = t.querySelector(".products-with-tabs__pagination"),
          a = Number(t.dataset.columns),
          i = a,
          o = 4 <= a ? i - 1 : i,
          c = 3 <= a ? 3 : i,
          n = 2 <= a ? 2 : c;
        let e = 1;
        t.classList.contains("products--2-mobile") && (e = 1 < a ? 2 : 1),
          new Swiper(t, {
            slidesPerView: e,
            slidesPerGroup: e,
            spaceBetween: 8,
            mousewheel: { forceToAxis: !0 },
            navigation: {
              nextEl: s.querySelector(".swiper-button-next"),
              prevEl: s.querySelector(".swiper-button-prev"),
            },
            pagination: {
              el: r,
              type: "custom",
              clickable: !0,
              renderCustom: function (e, t, s) {
                let r = "";
                for (let e = 1; e < s + 1; e++)
                  r =
                    e == t
                      ? `${r}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                      : `${r}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
                return r;
              },
            },
            breakpoints: {
              576: { slidesPerView: n, slidesPerGroup: n, spaceBetween: 8 },
              750: { slidesPerView: c, slidesPerGroup: c, spaceBetween: 8 },
              990: { slidesPerView: o, slidesPerGroup: o, spaceBetween: 8 },
              1200: { slidesPerView: i, slidesPerGroup: i, spaceBetween: 24 },
              1600: { slidesPerView: a, slidesPerGroup: a, spaceBetween: 24 },
            },
          });
      }
    },
    c = (e) => {
      e &&
        e.querySelectorAll(".products-with-tabs__slider").forEach((e) => {
          e.swiper && e.swiper.destroy();
        });
    },
    t = (i) => {
      if (i && i.classList.contains("products-with-tabs-section")) {
        let a = i.querySelectorAll(".products-with-tabs__tab");
        a.forEach((s) => {
          let r = s.dataset.productTab;
          s.addEventListener("click", (e) => {
            var t;
            e.currentTarget.classList.contains("button--secondary") ||
              (a.forEach((e) => {
                e.classList.remove("button--secondary"),
                  e.classList.add("button--tertiary");
              }),
              s.classList.remove("button--tertiary"),
              s.classList.add("button--secondary"),
              (e = i),
              (t = r),
              e &&
                (e
                  .querySelectorAll(".products-with-tabs__products")
                  .forEach((e) => {
                    e.classList.remove("products-with-tabs__products--active");
                  }),
                c(e),
                (e = e.querySelector(
                  `[data-product-tab="${t}"].products-with-tabs__products`,
                ))) &&
                (e.classList.add("products-with-tabs__products--active"),
                e.classList.contains("products-with-tabs__slider")) &&
                o(e));
          });
        });
      }
    },
    s = (e) => {
      e &&
        e.classList.contains("products-with-tabs-section") &&
        (e = e.querySelector(
          ".products-with-tabs__slider.products-with-tabs__products--active",
        )) &&
        o(e);
    };
  s(document.currentScript.parentElement),
    t(document.currentScript.parentElement),
    document.addEventListener("shopify:section:load", function (e) {
      s(e.target), t(e.target);
    });
})();
